import { FaEye, FaTimes } from "react-icons/fa";

const DocModal = ({ docLoading, docListData, docData, onClose }) => {
  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div className="dark:bg-custom-radial bg-[#F6F6F6] p-6 rounded shadow-lg relative max-w-xl min-h-[50%] w-full">
        <button
          onClick={onClose}
          className="absolute top-4 right-5 text-white font-bold"
        >
          <FaTimes
            className="cursor-pointer text-lightPrimary dark:text-darkWaring"
            fontSize={20}
          />
        </button>
        <h2 className="text-2xl font-semibold mb-4 text-lightPrimary dark:text-primary-gradient">
          Documents- {docData?.item_name}
        </h2>

        <table className="w-full text-base border-collapse">
          <thead>
            <tr className="border-b border-info dark:border-white font-bold text-justify text-info dark:text-grey">
              <th className="pl-3 pb-3">Doc Name</th>
              <th className="pl-3 pb-3">Action</th>
            </tr>
          </thead>
          <tbody>
            {docListData?.length > 0 ? (
              docListData.map((row, index) => (
                <tr key={index} className="">
                  <td className="p-3 text-lightPrimary dark:text-primary-gradient">
                    {row.name}
                  </td>
                  <td className="p-3 cursor-pointer text-primary hover:text-cyan-400">
                    <a href={row.url} target="_blank" rel="noopener noreferrer">
                      <FaEye />
                    </a>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="2"
                  className="p-4 text-center text-lightPrimary dark:text-primary-gradient"
                >
                  {docLoading ? "Loading..." : "No records found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DocModal;
